module.exports = __webpack_public_path__ + "static/media/parking.e38ae447.svg";